export type TimePeriod = {
  amount: number[];
  time_unit: ("weeks" | "days" | "hours" | "minutes" | "seconds")[];
};

export const decodeIso8601DurationToTimePeriod = (
  requestedDuration?: string,
): TimePeriod => {
  // Return empty result if duration is not provided
  if (!requestedDuration) {
    return {
      amount: [],
      time_unit: [],
    };
  }

  const regex =
    /^P(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?)?$/;

  const match = requestedDuration.match(regex);

  if (!match) {
    throw new Error(
      `Invalid or unsupported ISO 8601 duration: ${requestedDuration}`,
    );
  }

  const result: TimePeriod = {
    amount: [],
    time_unit: [],
  };

  if (match[1]) {
    result.amount.push(Number(match[1]));
    result.time_unit.push("weeks");
  }

  if (match[2]) {
    result.amount.push(Number(match[2]));
    result.time_unit.push("days");
  }

  if (match[3]) {
    result.amount.push(Number(match[3]));
    result.time_unit.push("hours");
  }

  if (match[4]) {
    result.amount.push(Number(match[4]));
    result.time_unit.push("minutes");
  }

  if (match[5]) {
    result.amount.push(Number(match[5]));
    result.time_unit.push("seconds");
  }

  if (result.amount.length === 0) {
    throw new Error(`Unsupported ISO 8601 duration: ${requestedDuration}`);
  }

  return result;
};
